<template>

    <div>
        <v-tabs v-model="model">
            <v-tab v-for="item in list" :key="item.key" :disabled="!item.show">{{ item.name }} <v-icon v-if="item.icon" right small>{{ item.icon }}</v-icon></v-tab>
        </v-tabs>

        <v-tabs-items v-model="model" class="py-3 px-2">
            <v-tab-item v-for="(item, index) in list" :key="item.key" :disabled="!item.show">
                <slot name="tab-items" :tab-key="item.key" :index="index"></slot>
            </v-tab-item>
        </v-tabs-items>
    </div>
    
</template>

<script setup>

import { ref, defineProps, watch, defineEmits } from 'vue'

const emit = defineEmits(['update:tab'])

const props = defineProps({
    tabs: { type: Array },
    tab: { type: Number, default: 0 }
})

const model = ref(props.tab)

const list = ref(props.tabs)

watch(() => props.tabs, function() {
    list.value = props.tabs
})

watch(() => props.tab, function(val){
    model.value = val
})

watch(model, function(val) {
    emit('update:tab', val)
})

</script>